import "./AppPreviewAndCodeStatusComponent.scss";
import { ImageConfig } from "@/constants";

interface AppPreviewAndCodeStatusComponentProps {
    type: "info" | "error" | "loading";
    title: string;
    description: string;
    children?: React.ReactNode;
}

const AppPreviewAndCodeStatusComponent = (props: AppPreviewAndCodeStatusComponentProps) => {

    const Icon = props.type === "error" ? ImageConfig.FlashDangerIcon : ImageConfig.FlashIcon;

    return (
        <div className={'app-preview-and-code-status-component'}>
            <Icon />
            <div className={'app-preview-and-code-status-component-title text-2xl'}>
                {props.title}
            </div>
            <div className={'app-preview-and-code-status-component-description text-l'}>
                {props.description}
            </div>
            {props.children}
        </div>
    );

};

export default AppPreviewAndCodeStatusComponent;
